import { render } from "./SideChatRoomSelection.vue?vue&type=template&id=f423e728"
import script from "./SideChatRoomSelection.vue?vue&type=script&lang=js"
export * from "./SideChatRoomSelection.vue?vue&type=script&lang=js"
script.render = render

export default script